export default "__VITE_ASSET__JtV6A_az__"